import { Link } from "react-router-dom";
import { useMatch } from "react-router-dom-v5-compat";

import { Box, Logo as SenekitLogo, useBreakpoint } from "@seneca/senekit";

import { linkToAnonymousCourseDiscoveryWithDefaultFilters } from "features/anonymous-pages/course-discovery/links";
import useAppVariant from "features/common/hooks/useAppVariant";
import Logo from "features/common/logos/Logo";
import ParentLogo from "features/common/logos/ParentLogo";
import { ROUTES } from "routing/routes";

import styles from "./LogoPageWrapper.module.scss";

export default function LogoComponent() {
  const Component = useComponentVariant();

  return <Component />;
}

function useComponentVariant() {
  const appVariant = useAppVariant();

  const urlMatchesSignInParentViaLink = !!useMatch(
    ROUTES.SIGN_IN_PARENT_VIA_LINK
  );
  const urlMatchesSignUpParent = !!useMatch(ROUTES.SIGN_UP_PARENT.path);

  const urlMatchesGlobalParentRoute =
    urlMatchesSignUpParent || urlMatchesSignInParentViaLink;

  const valuesByVariant = {
    seneca: urlMatchesGlobalParentRoute
      ? ParentLogoComponent
      : LogoLinkingToCourseDiscovery,
    senecaPrimary: LogoLinkingToCourseDiscovery,
    plurall: PlainLogoComponent,
    goStudentLearning: PlainLogoComponent
  };

  return valuesByVariant[appVariant];
}

function PlainLogoComponent() {
  return (
    <Logo className={styles.logo} width="auto" height={["30px", "40px"]} />
  );
}

function LogoLinkingToCourseDiscovery() {
  return (
    <Link to={linkToAnonymousCourseDiscoveryWithDefaultFilters()}>
      <PlainLogoComponent />
    </Link>
  );
}

function ParentLogoComponent() {
  const { isMobileOnly } = useBreakpoint();

  return (
    <Link to={linkToAnonymousCourseDiscoveryWithDefaultFilters()}>
      <Box
        position="absolute"
        top="20px"
        width={["128px", "176px"]}
        marginX={["large", "xlarge"]}
      >
        {isMobileOnly ? (
          <SenekitLogo variant="goStudent" height={["30px", "40px"]} />
        ) : (
          <ParentLogo />
        )}
      </Box>
    </Link>
  );
}
